

import React, { Component } from "react"
import { Icon,Tag } from 'antd'
import '../../css/svr_review_react.css'
class AmbPriceSummaryView extends Component{
    getTaxListContainer(taxList,cur){
       return taxList.map((o,idx)=>{
            return (
                <p>
                <dl>
                    <dt className="tax-ib-info"><span className="nh"><text className="tax-line"> {o.type?o.type :'TaxCode' }  </text></span></dt>
                    <dd className="tax-ib-amt"><span className="n2">{cur}{o.amount?o.amount:'49.26' } </span> </dd>
                </dl>

                </p>
            )

        })

    }
    constructor(props){
        super(props)
        let me = this
        this.getTaxListContainer = this.getTaxListContainer.bind(me)
        this.svrstars = {
            "sv_rating_no": 5,
            "color": "#e8a01899"
        }
            }
    render(){
        const {price} = this.props
       
        
        let cur = (price.currency == 'USD') ? "$": price.currency

        let taxList = []
        let ntotal = 0
        let nbase = 0
        let nothers = 0
         if(price && price.fees){
             taxList = price.fees
             ntotal = parseInt(price.total)
             nbase = parseInt(price.base)
             nothers = ntotal - nbase 


         }
        
        
       
        return (
            <div className="rev-row ">
                <div className="card card--raised with-shadow">
                <p className="sd-content"> <text> Yours Price Summary </text></p>
                <div className="box-outer">
                    <div className="box-left">
                        <text> Total </text>
                    </div>

                    <div className="box-right">

                        <p><text className="f19">{cur}{price.total?price.total :'923.46' }  </text></p>
                        <p><text className="f17sv">Include taxes and fees </text></p>


                    </div>

                </div>
                <p className="sd-content"> <text> Base Price : {cur}{price.base} </text></p>
                <p className="sd-content"> <text> Price Information </text></p>
                <p><span style={{fontSize: "16px"}} > <Icon  style={{ color: 'rgb(206, 209, 24)' }} type="sketch-square" theme="filled" /><text style={{paddingLeft: "10px"}}>Includes Fees {price.currency} {nothers } in taxes and fess </text></span></p>
                {/* 
                <p> <text className="tax-bl-total"> Incude {price.tax.taxTotal?price.tax.taxTotal:'$102.34' } in taxes and fess </text></p>
                 */}
                 { this.getTaxListContainer(taxList,cur)}
               
               
                </div>  
            </div>
)
    }
   
}

export default AmbPriceSummaryView;